module.exports = __webpack_public_path__ + "static/media/top_10_vertical.2ae5836c.png";